import CookieBot from './CookieBot'
import MetaPixel from './MetaPixel'

const SharedAnalytics = () => {
  return (
    <>
      <MetaPixel />
      <CookieBot />
    </>
  )
}

export default SharedAnalytics
